<template>
	<transition
			appear
			:appear-active-class="$_inpLyt_stylePageLayoutAnimation()">
		<v-row id="_inpLyt_top" class="customVRow" no-gutters>
			<v-col>
				<v-stepper
						v-model="stepNumber_"
						class="stepper_"
						:dark="$_inpLyt_styleStepperDark"
						:light="$_inpLyt_styleStepperLight"
						:vertical="$_inpLyt_stateAppIsMobileScreen">
					<!-- stepper header ( only for web ) -->
					<template v-if="!$_inpLyt_stateAppIsMobileScreen">
						<v-row no-gutters>
							<v-col>
								<v-sheet
										class="customVSheet px-3 ma-3"
										:color="$_inpLyt_styleStepperSheetColor"
										:dark="$_inpLyt_styleStepperSheetDark"
										:elevation="$_inpLyt_styleStepperSheetElevation"
										:light="$_inpLyt_styleStepperSheetLight">
									<v-stepper-header class="stepperHeader_">
										<v-row>
											<template v-for="(stepVals, stepKey) in step_">
												<v-col :key="stepKey">
													<v-card	class="customVCard"
															:color="$_inpLyt_styleStepperHeaderCardColor"
															:dark="$_inpLyt_styleStepperHeaderCardDark"
															:elevation="$_inpLyt_styleStepperHeaderCardElevation"
															:flat="$_inpLyt_styleStepperHeaderCardFlat"
															:hover="$_inpLyt_styleStepperHeaderCardHover"
															:light="$_inpLyt_styleStepperHeaderCardLight"
															:outlined="$_inpLyt_styleStepperHeaderCardOutlined"
															:raised="$_inpLyt_styleStepperHeaderCardRaised"
															:tile="$_inpLyt_styleStepperHeaderCardTile">
														<v-stepper-step 
																class="stepperStep_"
																:color="$_inpLyt_styleStepperStepColor"
																:complete="completed_[stepKey]"
																:step="stepVals.step">
															<span v-html="stepVals.title" />
														</v-stepper-step>
													</v-card>
												</v-col>
											</template>
										</v-row>
									</v-stepper-header>
								</v-sheet>
							</v-col>
						</v-row>
					</template>
					<!-- stepper body ( input mode ) -->
					<v-stepper-items class="stepperItem_">
						<!-- stepper body - step head (only for mobile) -->
						<template v-if="$_inpLyt_stateAppIsMobileScreen">
							<v-row>
								<v-col>
									<v-sheet
											class="customVSheet px-3 ma-3"
											:color="$_inpLyt_styleStepperSheetColor"
											:dark="$_inpLyt_styleStepperSheetDark"
											:elevation="$_inpLyt_styleStepperSheetElevation"
											:light="$_inpLyt_styleStepperSheetLight">
										<v-row>
											<v-col>
												<v-card class="customVCard"
														:color="$_inpLyt_styleStepperHeaderCardColor"
														:dark="$_inpLyt_styleStepperHeaderCardDark"
														:elevation="$_inpLyt_styleStepperHeaderCardElevation"
														:flat="$_inpLyt_styleStepperHeaderCardFlat"
														:hover="$_inpLyt_styleStepperHeaderCardHover"
														:light="$_inpLyt_styleStepperHeaderCardLight"
														:outlined="$_inpLyt_styleStepperHeaderCardOutlined"
														:raised="$_inpLyt_styleStepperHeaderCardRaised"
														:tile="$_inpLyt_styleStepperHeaderCardTile">
													<v-stepper-step
															class="stepperStep_"
															:color="$_inpLyt_styleStepperStepColor"
															:complete="completed_.input"
															:step="step_.input.step">
														<span v-html="step_.input.title" />
													</v-stepper-step>
												</v-card>
											</v-col>
										</v-row>
									</v-sheet>
								</v-col>
							</v-row>
						</template>
						<!-- stepper body - step body -->
						<v-stepper-content
								class="stepperContent_"
								:step="step_.input.step">
							<validation-observer v-slot="validation">
								<v-form>
									<template v-if="errorMessage_">
										<v-row>
											<v-col>
												<span v-html="errorMessage_" />
											</v-col>
										</v-row>
									</template>
									<v-row>
										<v-col>
											<v-sheet
													class="customVSheet px-3 ma-3"
													:color="$_inpLyt_styleStepperSheetColor"
													:dark="$_inpLyt_styleStepperSheetDark"
													:elevation="$_inpLyt_styleStepperSheetElevation"
													:light="$_inpLyt_styleStepperSheetLight">
												<template v-for="(contentVals, contentKey) in sortObject(contents, 'order')">
													<template v-if="checkMenuGroup(contentVals.menuGroup, true) && checkSecurityGroup(contentVals.securityGroup, true)">
														<template v-if="contentVals.title">
															<v-row :key="`title-${contentKey}`">
																<v-col>
																	<v-card class="customVCard"
																			:color="$_inpLyt_styleStepperBodyCardColor"
																			:dark="$_inpLyt_styleStepperBodyCardDark"
																			:elevation="$_inpLyt_styleStepperBodyCardElevation"
																			:flat="$_inpLyt_styleStepperBodyCardFlat"
																			:hover="$_inpLyt_styleStepperBodyCardHover"
																			:light="$_inpLyt_styleStepperBodyCardLight"
																			:outlined="$_inpLyt_styleStepperBodyCardOutlined"
																			:raised="$_inpLyt_styleStepperBodyCardRaised"
																			:tile="$_inpLyt_styleStepperBodyCardTile">
																		<v-card-text>
																			<v-row dense>
																				<v-col>
																					<span	class="title"
																							v-html="$_inpLyt_langContentTitle(contentVals)" />
																				</v-col>
																			</v-row>
																		</v-card-text>
																	</v-card>
																</v-col>
															</v-row>
														</template>
														<v-row :key="`content-${contentKey}`">
															<v-col>
																<v-card class="customVCard"
																		:color="$_inpLyt_styleStepperBodyCardColor"
																		:dark="$_inpLyt_styleStepperBodyCardDark"
																		:elevation="$_inpLyt_styleStepperBodyCardElevation"
																		:flat="$_inpLyt_styleStepperBodyCardFlat"
																		:hover="$_inpLyt_styleStepperBodyCardHover"
																		:light="$_inpLyt_styleStepperBodyCardLight"
																		:outlined="$_inpLyt_styleStepperBodyCardOutlined"
																		:raised="$_inpLyt_styleStepperBodyCardRaised"
																		:tile="$_inpLyt_styleStepperBodyCardTile">
																	<template v-if="isObject(contentVals.bigImage)">
																		<v-row>
																			<v-col>
																				<v-img	class="customVImg"
																						:src="$_inpLyt_styleContentBigImageUrl(contentVals)" />
																			</v-col>
																		</v-row>
																	</template>
																	<template v-if="isObject(contentVals.video)">
																		<v-row>
																			<v-col>
																				<card-video
																						:contentKey="contentKey"
																						:contents="contents"
																						:inits="inits" />
																			</v-col>
																		</v-row>
																	</template>
																	<v-row>
																		<template v-if="!isFalse($_inpLyt_langContentText(contentVals))">
																			<v-col>
																				<v-card-text>
																					<v-row no-gutters>
																						<v-col>
																							<span 	class="subtitle-1 markdown"
																									v-html="marked($_inpLyt_langContentText(contentVals))" />
																						</v-col>
																					</v-row>
																				</v-card-text>
																			</v-col>
																		</template>
																		<template v-if="isObject(contentVals.image)">
																			<v-col cols="12" md="4" class="center">
																				<v-img	class="customVImg"
																						:src="$_inpLyt_styleContentImageUrl(contentVals)" />
																			</v-col>
																		</template>
																	</v-row>
																	<v-row>
																		<v-col>
																			<v-card-text>
																				<!-- check box -->
																				<template v-if="contentVals.type.checkbox">
																					<v-row no-gutters>
																						<v-col>
																							<input-checkbox
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- combobox -->
																				<template v-if="contentVals.type.combobox">
																					<v-row no-gutters>
																						<v-col>
																							<input-combobox
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- combobox multiple -->
																				<template v-if="contentVals.type.comboboxMultiple">
																					<v-row no-gutters>
																						<v-col>
																							<input-combobox-multiple
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- radio button -->
																				<template v-if="contentVals.type.radioButton">
																					<v-row no-gutters>
																						<v-col>
																							<input-radio-button
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- select -->
																				<template v-if="contentVals.type.select">
																					<v-row no-gutters>
																						<v-col>
																							<input-select
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- select multiple -->
																				<template v-if="contentVals.type.selectMultiple">
																					<v-row no-gutters>
																						<v-col>
																							<input-select-multiple
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- slider -->
																				<template v-if="contentVals.type.slider">
																					<v-row no-gutters>
																						<v-col>
																							<input-slider
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- switch -->
																				<template v-if="contentVals.type.switch">
																					<v-row no-gutters>
																						<v-col>
																							<input-switch
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- textarea -->
																				<template v-if="contentVals.type.textarea">
																					<v-row no-gutters>
																						<v-col>
																							<input-textarea
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																				<!-- text field -->
																				<template v-if="contentVals.type.textField">
																					<v-row no-gutters>
																						<v-col>
																							<input-text-field
																									:contentKey="contentKey"
																									:contents="contents"
																									:inits="inits" />
																						</v-col>
																					</v-row>
																				</template>
																			</v-card-text>
																		</v-col>
																	</v-row>
																	<!-- action buttons --> 
																	<template v-if="!isEmpty(contentVals.actionButtons)">
																		<v-row>
																			<v-col>
																				<v-card-actions>
																					<v-row dense>
																						<template v-for="(actionButtonVals, actionButtonKey) in sortObject(contentVals.actionButtons, 'order')">
																							<v-col :key="actionButtonKey" cols="auto">
																								<v-btn	class="customVBtn"
																										:block="$_inpLyt_styleQuestionActionButtonBlock"
																										:color="$_inpLyt_styleQuestionActionButtonColor"
																										:dark="$_inpLyt_styleQuestionActionButtonDark"
																										:depressed="$_inpLyt_styleQuestionActionButtonDepressed"
																										:elevation="$_inpLyt_styleQuestionActionButtonElevation"
																										:large="$_inpLyt_styleQuestionActionButtonLarge"
																										:light="$_inpLyt_styleQuestionActionButtonLight"
																										:outlined="$_inpLyt_styleQuestionActionButtonOutlined"
																										:rounded="$_inpLyt_styleQuestionActionButtonRounded"
																										:small="$_inpLyt_styleQuestionActionButtonSmall"
																										:text="$_inpLyt_styleQuestionActionButtonFlat"
																										@click="openLink(actionButtonVals.link)"
																										v-text="$_inpLyt_langActionButtonTitle(actionButtonVals)" />
																							</v-col>
																						</template>
																					</v-row>
																				</v-card-actions>
																			</v-col>
																		</v-row>
																	</template>
																</v-card>
															</v-col>
														</v-row>
													</template>
												</template>
											</v-sheet>
										</v-col>
									</v-row>
									<v-row	align="center"
											justify="center">
										<v-col cols="auto">
											<v-btn	class="customVBtn"
													:block="$_inpLyt_styleStepperActionButtonBlock"
													:color="$_inpLyt_styleStepperActionButtonColorSubmit"
													:dark="!validation.passed && !validation.valid ? $_inpLyt_stateAppIsDarkTheme : $_inpLyt_styleStepperActionButtonDark"
													:depressed="$_inpLyt_styleStepperActionButtonDepressed"
													:elevation="$_inpLyt_styleStepperActionButtonElevation"
													:large="$_inpLyt_styleStepperActionButtonLarge"
													:light="$_inpLyt_styleStepperActionButtonLight"
													:outlined="$_inpLyt_styleStepperActionButtonOutlined"
													:rounded="$_inpLyt_styleStepperActionButtonRounded"
													:small="$_inpLyt_styleStepperActionButtonSmall"
													:text="$_inpLyt_styleStepperActionButtonFlat"

													:disabled="!validation.passed && !validation.valid"

													@click="$_inpLyt_submit()"
													v-text="$_inpLyt_langSubmitButton" />
										</v-col>
									</v-row>
								</v-form>
							</validation-observer>
						</v-stepper-content>
					</v-stepper-items>
					<!-- stepper body ( submit mode ) -->
					<v-stepper-items class="stepperItem_">
						<!-- stepper body - step header (only for mobile) -->
						<template v-if="$_inpLyt_stateAppIsMobileScreen">
							<v-row no-gutters>
								<v-col>
									<v-sheet
											class="customVSheet px-3 ma-3"
											:color="$_inpLyt_styleStepperSheetColor"
											:dark="$_inpLyt_styleStepperSheetDark"
											:elevation="$_inpLyt_styleStepperSheetElevation"
											:light="$_inpLyt_styleStepperSheetLight">
										<v-row>
											<v-col>
												<v-card class="customVCard"
														:color="$_inpLyt_styleStepperHeaderCardColor"
														:dark="$_inpLyt_styleStepperHeaderCardDark"
														:elevation="$_inpLyt_styleStepperHeaderCardElevation"
														:flat="$_inpLyt_styleStepperHeaderCardFlat"
														:hover="$_inpLyt_styleStepperHeaderCardHover"
														:light="$_inpLyt_styleStepperHeaderCardLight"
														:outlined="$_inpLyt_styleStepperHeaderCardOutlined"
														:raised="$_inpLyt_styleStepperHeaderCardRaised"
														:tile="$_inpLyt_styleStepperHeaderCardTile">
													<v-stepper-step
															class="stepperStep_"
															:color="$_inpLyt_styleStepperStepColor"
															:complete="completed_.submit"
															:step="step_.submit.step">
														<span v-html="step_.submit.title" />
													</v-stepper-step>
												</v-card>
											</v-col>
										</v-row>
									</v-sheet>
								</v-col>
							</v-row>
						</template>
						<!-- stepper body - step body -->
						<v-stepper-content
								class="stepperContent_"
								:step="step_.submit.step">
							<v-row>
								<v-col>
									<v-sheet
											class="customVSheet px-3 ma-3"
											:color="$_inpLyt_styleStepperSheetColor"
											:dark="$_inpLyt_styleStepperSheetDark"
											:elevation="$_inpLyt_styleStepperSheetElevation"
											:light="$_inpLyt_styleStepperSheetLight">
										<template v-for="(answerVals, answerKey) in sortObject($_inpLyt_stateInputData, 'order')">
											<template v-if="answerVals.question.title">
												<v-row :key="`title-${answerKey}`">
													<v-col>
														<v-card class="customVCard"
																:color="$_inpLyt_styleStepperBodyCardColor"
																:dark="$_inpLyt_styleStepperBodyCardDark"
																:elevation="$_inpLyt_styleStepperBodyCardElevation"
																:flat="$_inpLyt_styleStepperBodyCardFlat"
																:hover="$_inpLyt_styleStepperBodyCardHover"
																:light="$_inpLyt_styleStepperBodyCardLight"
																:outlined="$_inpLyt_styleStepperBodyCardOutlined"
																:raised="$_inpLyt_styleStepperBodyCardRaised"
																:tile="$_inpLyt_styleStepperBodyCardTile">
															<v-card-text>
																<v-row dense>
																	<v-col>
																		<span	class="title"
																				v-html="answerVals.question.title" />
																	</v-col>
																</v-row>
															</v-card-text>
														</v-card>
													</v-col>
												</v-row>
											</template>
											<v-row :key="`content-${answerKey}`">
												<v-col>
													<v-card class="customVCard"
															:color="$_inpLyt_styleStepperBodyCardColor"
															:dark="$_inpLyt_styleStepperBodyCardDark"
															:elevation="$_inpLyt_styleStepperBodyCardElevation"
															:flat="$_inpLyt_styleStepperBodyCardFlat"
															:hover="$_inpLyt_styleStepperBodyCardHover"
															:light="$_inpLyt_styleStepperBodyCardLight"
															:outlined="$_inpLyt_styleStepperBodyCardOutlined"
															:raised="$_inpLyt_styleStepperBodyCardRaised"
															:tile="$_inpLyt_styleStepperBodyCardTile">
														<template v-if="!isFalse(answerVals.question.text)">
															<v-card-title>
																<v-row dense>
																	<v-col>
																		<span	class="subtitle-1 markdown"
																				v-html="marked(answerVals.question.text)" />
																	</v-col>
																</v-row>
															</v-card-title>
														</template>
														<v-card-text>
															<template v-if="answerVals.type == 'checkbox' || answerVals.type == 'switch'">
																<v-row dense>
																	<template v-for="(vals, key) in answerVals.answer">
																		<template v-if="vals.value">
																			<v-col :key="key" cols="auto">
																				<span 	class="subtitle-1"
																						v-html="vals.text" />
																			</v-col>
																		</template>
																	</template>
																</v-row>
															</template>
															<template v-else-if="answerVals.type == 'combobox'">
																<v-row dense>
																	<v-col cols="auto">
																		<template v-if="isObject(answerVals.answer)">
																			<span	class="subtitle-1"
																					v-html="answerVals.answer.text" />
																		</template>
																		<template v-else>
																			<span 	class="subtitle-1"
																					v-html="answerVals.answer" />
																		</template>
																	</v-col>
																</v-row>
															</template>
															<template v-else-if="answerVals.type == 'comboboxMultiple'">
																<v-row dense>
																	<template v-for="(vals, key) in answerVals.answer">
																		<template v-if="isObject(vals)">
																			<v-col :key="key" cols="auto">
																				<span 	class="subtitle-1"
																						v-html="vals.text" />
																			</v-col>
																		</template>
																		<template v-else>
																			<v-col :key="key" cols="auto">
																				<span 	class="subtitle-1"
																						v-html="vals" />
																			</v-col>
																		</template>
																	</template>
																</v-row>
															</template>
															<template v-else-if="answerVals.type == 'radioButton' || answerVals.type == 'select'">
																<v-row dense>
																	<v-col cols="auto">
																		<span 	class="subtitle-1"
																				v-html="answerVals.answer.text" />
																	</v-col>
																</v-row>
															</template>
															<template v-else-if="answerVals.type == 'selectMultiple'">
																<v-row dense>
																	<template v-for="(vals, key) in answerVals.answer">
																		<v-col :key="key" cols="auto">
																			<span 	class="subtitle-1"
																					v-html="vals.text" />
																		</v-col>
																	</template>
																</v-row>
															</template>
															<template v-else>
																<v-row dense>
																	<v-col cols="auto">
																		<span 	class="subtitle-1"
																				v-html="answerVals.answer" />
																	</v-col>
																</v-row>
															</template>
														</v-card-text>
													</v-card>
												</v-col>
											</v-row>
										</template>
									</v-sheet>
								</v-col>
							</v-row>
							<v-row	align="center"
									justify="center">
								<!-- back button -->
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_inpLyt_styleStepperActionButtonBlock"
											:color="$_inpLyt_styleStepperActionButtonColor('backStep')"
											:dark="$_inpLyt_styleStepperActionButtonDark"
											:depressed="$_inpLyt_styleStepperActionButtonDepressed"
											:elevation="$_inpLyt_styleStepperActionButtonElevation"
											:large="$_inpLyt_styleStepperActionButtonLarge"
											:light="$_inpLyt_styleStepperActionButtonLight"
											:outlined="$_inpLyt_styleStepperActionButtonOutlined"
											:rounded="$_inpLyt_styleStepperActionButtonRounded"
											:small="$_inpLyt_styleStepperActionButtonSmall"
											:text="$_inpLyt_styleStepperActionButtonFlat"
											@click="$_inpLyt_back()"
											v-text="$_inpLyt_langBackButton" />
								</v-col>
								<!-- confirm button -->
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_inpLyt_styleStepperActionButtonBlock"
											:color="$_inpLyt_styleStepperActionButtonColor('confirm')"
											:dark="$_inpLyt_styleStepperActionButtonDark"
											:depressed="$_inpLyt_styleStepperActionButtonDepressed"
											:elevation="$_inpLyt_styleStepperActionButtonElevation"
											:large="$_inpLyt_styleStepperActionButtonLarge"
											:light="$_inpLyt_styleStepperActionButtonLight"
											:outlined="$_inpLyt_styleStepperActionButtonOutlined"
											:rounded="$_inpLyt_styleStepperActionButtonRounded"
											:small="$_inpLyt_styleStepperActionButtonSmall"
											:text="$_inpLyt_styleStepperActionButtonFlat"
											@click="$_inpLyt_confirm()">
										<template v-if="onProgress_">
											<progress-circular />
										</template>
										<template v-else>
											<span v-text="$_inpLyt_langConfirmButton" />
										</template>
									</v-btn>
								</v-col>
							</v-row>
						</v-stepper-content>
					</v-stepper-items>
					<!-- stepper body ( finish mode ) -->
					<v-stepper-items class="stepperItem_">
						<!-- stepper body - step header (only for mobile) -->
						<template v-if="$_inpLyt_stateAppIsMobileScreen">
							<v-row no-gutters>
								<v-col>
									<v-sheet
											class="customVSheet px-3 ma-3"
											:color="$_inpLyt_styleStepperSheetColor"
											:dark="$_inpLyt_styleStepperSheetDark"
											:elevation="$_inpLyt_styleStepperSheetElevation"
											:light="$_inpLyt_styleStepperSheetLight">
										<v-row>
											<v-col>
												<v-card class="customVCard"
														:color="$_inpLyt_styleStepperHeaderCardColor"
														:dark="$_inpLyt_styleStepperHeaderCardDark"
														:elevation="$_inpLyt_styleStepperHeaderCardElevation"
														:flat="$_inpLyt_styleStepperHeaderCardFlat"
														:hover="$_inpLyt_styleStepperHeaderCardHover"
														:light="$_inpLyt_styleStepperHeaderCardLight"
														:outlined="$_inpLyt_styleStepperHeaderCardOutlined"
														:raised="$_inpLyt_styleStepperHeaderCardRaised"
														:tile="$_inpLyt_styleStepperHeaderCardTile">
													<v-stepper-step
															class="stepperStep_"
															:color="$_inpLyt_styleStepperStepColor"
															:complete="completed_.finish"
															:step="step_.finish.step">
														<span v-html="step_.finish.title" />
													</v-stepper-step>
												</v-card>
											</v-col>
										</v-row>
									</v-sheet>
								</v-col>
							</v-row>
						</template>
						<!-- stepper body - step body -->
						<v-stepper-content
								class="stepperContent_"
								:step="step_.finish.step">
							<v-row>
								<v-col>
									<v-sheet
											class="customVSheet px-3 ma-3"
											:color="$_inpLyt_styleStepperSheetColor"
											:dark="$_inpLyt_styleStepperSheetDark"
											:elevation="$_inpLyt_styleStepperSheetElevation"
											:light="$_inpLyt_styleStepperSheetLight">
										<v-row>
											<v-col>
												<v-card class="customVCard"
														:color="$_inpLyt_styleStepperBodyCardColor"
														:dark="$_inpLyt_styleStepperBodyCardDark"
														:elevation="$_inpLyt_styleStepperBodyCardElevation"
														:flat="$_inpLyt_styleStepperBodyCardFlat"
														:hover="$_inpLyt_styleStepperBodyCardHover"
														:light="$_inpLyt_styleStepperBodyCardLight"
														:outlined="$_inpLyt_styleStepperBodyCardOutlined"
														:raised="$_inpLyt_styleStepperBodyCardRaised"
														:tile="$_inpLyt_styleStepperBodyCardTile">
													<v-card-text>
														<v-row dense>
															<v-col>
																<span 	class="title"
																		v-html="$_inpLyt_langFinishedText" />
															</v-col>
														</v-row>
													</v-card-text>
												</v-card>
											</v-col>
										</v-row>
									</v-sheet>
								</v-col>
							</v-row>
							<v-row	align="center"
									justify="center">
								<!-- ok button -->
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_inpLyt_styleStepperActionButtonBlock"
											:color="$_inpLyt_styleStepperActionButtonColor('finish')"
											:dark="$_inpLyt_styleStepperActionButtonDark"
											:depressed="$_inpLyt_styleStepperActionButtonDepressed"
											:elevation="$_inpLyt_styleStepperActionButtonElevation"
											:large="$_inpLyt_styleStepperActionButtonLarge"
											:light="$_inpLyt_styleStepperActionButtonLight"
											:outlined="$_inpLyt_styleStepperActionButtonOutlined"
											:rounded="$_inpLyt_styleStepperActionButtonRounded"
											:small="$_inpLyt_styleStepperActionButtonSmall"
											:text="$_inpLyt_styleStepperActionButtonFlat"
											@click="openLink($_inpLyt_linkOkButton)"
											v-text="$_inpLyt_langOkButton" />
								</v-col>
							</v-row>
						</v-stepper-content>
					</v-stepper-items>
				</v-stepper>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'InputLayout',
		props: {
			contents: Object,
			inits: Object
		},
		data() {
			return {
				valid_: true,

				errorMessage_: null,
				onProgress_: false,

				stepNumber_: 1,

				mode_: {
					input: true,
					submit: false,
					finish: false
				},

				completed_: {
					input: false,
					submit: false,
					finish: false
				},

				step_: {
					input: {
						step: 1,
						title: 'Input'
					},
					submit: {
						step: 2,
						title: 'Submit'
					},
					finish: {
						step: 3,
						title: 'Finished'
					}
				}
			}
		},
		computed: {
			// current user
			$_inpLyt_currentUserUid() {
				const self_ = this;
				return self_.getCurrentUser('uid')
			},
			// state
			$_inpLyt_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			$_inpLyt_stateAppIsDarkTheme() {
				const self_ = this;
				return self_.getAppState('isDarkTheme')
			},
			$_inpLyt_stateInput() {
				const self_ = this;
				return self_.getInputState()
			},
			$_inpLyt_stateInputData() {
				const self_ = this;
				const input_ = self_.$_inpLyt_stateInput
				if(self_.isFalse(input_)) { return null }
				return input_.data
			},
			$_inpLyt_statePageName() {
				const self_ = this;
				return self_.getPageState('name')
			},
			$_inpLyt_statePageType() {
				const self_ = this;
				return self_.getPageState('type')
			},
			// info
			$_inpLyt_infoContact() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.inits, 'contact')
			},
			$_inpLyt_infoContactUid() {
				const self_ = this;
				const contact_ = self_.$_inpLyt_infoContact;
				if(self_.isEmpty(contact_)) { return null }
				return contact_.uid
			},
			$_inpLyt_infoMessage() {
				const self_ = this;
				return self_.getInitsInfoVal(self_.inits, 'message')
			},
			$_inpLyt_infoMessageTitle() {
				const self_ = this;
				const message_ = self_.$_inpLyt_infoMessage;
				if(self_.isEmpty(message_)) { return null }
				return message_.title
			},
			$_inpLyt_infoMessageText() {
				const self_ = this;
				const message_ = self_.$_inpLyt_infoMessage;
				if(self_.isEmpty(message_)) { return null }
				return message_.text
			},
			// lang
			$_inpLyt_langBackButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'backButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_inpLyt_langSubmitButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'submitButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_inpLyt_langConfirmButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'confirmButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_inpLyt_langFinishedText() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'finishText')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			$_inpLyt_langOkButton() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'okButton')
				if(self_.isFalse(lang_)) { return null }
				return self_.getLangsVal(lang_)
			},
			// (content)
			$_inpLyt_langContentTitle() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.title;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			$_inpLyt_langContentText() {
				const self_ = this;
				return contentVals => {
					const contentVal_ = contentVals.text;
					if(self_.isFalse(contentVal_)) { return null }
					return self_.getLangsVal(contentVal_)
				}
			},
			// (content - action button)
			$_inpLyt_langActionButtonTitle() {
				const self_ = this;
				return actionButtonVals => {
					const actionButtonVal_ = actionButtonVals.title;
					if(self_.isFalse(actionButtonVal_)) { return null }
					return self_.getLangsVal(actionButtonVal_)
				}
			},
			// link
			$_inpLyt_linkOkButton() {
				const self_ = this;
				return self_.getInitsLinkVal(self_.inits, 'okButton')
			},
			// style
			$_inpLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_inpLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_inpLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_inpLyt_styleStepper() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepper')
			},
			$_inpLyt_styleStepperDark() {
				const self_ = this;
				const stepper_ = self_.$_inpLyt_styleStepper;
				if(self_.isFalse(stepper_)) { return null }
				return self_.getStylesVal(stepper_.dark)
			},
			$_inpLyt_styleStepperLight() {
				const self_ = this;
				const stepper_ = self_.$_inpLyt_styleStepper;
				if(self_.isFalse(stepper_)) { return null }
				return self_.getStylesVal(stepper_.light)
			},
			$_inpLyt_styleStepperStepColor() {
				const self_ = this;
				const stepper_ = self_.$_inpLyt_styleStepper;
				if(self_.isFalse(stepper_)) { return null }
				return self_.getStylesVal(stepper_.stepColor)
			},
			$_inpLyt_styleStepperSheet() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepperSheet')
			},
			$_inpLyt_styleStepperSheetColor() {
				const self_ = this;
				const card_ = self_.$_inpLyt_styleStepperSheet;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_inpLyt_styleStepperSheetDark() {
				const self_ = this;
				const card_ = self_.$_inpLyt_styleStepperSheet;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_inpLyt_styleStepperSheetElevation() {
				const self_ = this;
				const card_ = self_.$_inpLyt_styleStepperSheet;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_inpLyt_styleStepperSheetLight() {
				const self_ = this;
				const card_ = self_.$_inpLyt_styleStepperSheet;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_inpLyt_styleStepperHeaderCard() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepperHeaderCard')
			},
			$_inpLyt_styleStepperHeaderCardColor() {
				const self_ = this;
				const card_ = self_.$_inpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_inpLyt_styleStepperHeaderCardDark() {
				const self_ = this;
				const card_ = self_.$_inpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_inpLyt_styleStepperHeaderCardElevation() {
				const self_ = this;
				const card_ = self_.$_inpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_inpLyt_styleStepperHeaderCardFlat() {
				const self_ = this;
				const card_ = self_.$_inpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.flat)
			},
			$_inpLyt_styleStepperHeaderCardHover() {
				const self_ = this;
				const card_ = self_.$_inpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.hover)
			},
			$_inpLyt_styleStepperHeaderCardLight() {
				const self_ = this;
				const card_ = self_.$_inpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_inpLyt_styleStepperHeaderCardOutlined() {
				const self_ = this;
				const card_ = self_.$_inpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.outlined)
			},
			$_inpLyt_styleStepperHeaderCardRaised() {
				const self_ = this;
				const card_ = self_.$_inpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.raised)
			},
			$_inpLyt_styleStepperHeaderCardTile() {
				const self_ = this;
				const card_ = self_.$_inpLyt_styleStepperHeaderCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.tile)
			},
			$_inpLyt_styleStepperBodyCard() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepperBodyCard')
			},
			$_inpLyt_styleStepperBodyCardColor() {
				const self_ = this;
				const card_ = self_.$_inpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_inpLyt_styleStepperBodyCardDark() {
				const self_ = this;
				const card_ = self_.$_inpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_inpLyt_styleStepperBodyCardElevation() {
				const self_ = this;
				const card_ = self_.$_inpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_inpLyt_styleStepperBodyCardFlat() {
				const self_ = this;
				const card_ = self_.$_inpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.flat)
			},
			$_inpLyt_styleStepperBodyCardHover() {
				const self_ = this;
				const card_ = self_.$_inpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.hover)
			},
			$_inpLyt_styleStepperBodyCardLight() {
				const self_ = this;
				const card_ = self_.$_inpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_inpLyt_styleStepperBodyCardOutlined() {
				const self_ = this;
				const card_ = self_.$_inpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.outlined)
			},
			$_inpLyt_styleStepperBodyCardRaised() {
				const self_ = this;
				const card_ = self_.$_inpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.raised)
			},
			$_inpLyt_styleStepperBodyCardTile() {
				const self_ = this;
				const card_ = self_.$_inpLyt_styleStepperBodyCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.tile)
			},
			$_inpLyt_styleStepperActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'stepperActionButton')
			},
			$_inpLyt_styleStepperActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_inpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_inpLyt_styleStepperActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_inpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return key => {
					if(self_.isObject(actionButton_.color)) {
						return	self_.getStylesVal(actionButton_.color[key]) ||
								self_.getStylesVal(actionButton_.color.default)
					} else {
						return self_.getStylesVal(actionButton_.color)
					}
				}
			},
			$_inpLyt_styleStepperActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_inpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_inpLyt_styleStepperActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_inpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_inpLyt_styleStepperActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_inpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_inpLyt_styleStepperActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_inpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_inpLyt_styleStepperActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_inpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_inpLyt_styleStepperActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_inpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_inpLyt_styleStepperActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_inpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_inpLyt_styleStepperActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_inpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_inpLyt_styleStepperActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_inpLyt_styleStepperActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			$_inpLyt_styleQuestionActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'questionActionButton')
			},
			$_inpLyt_styleQuestionActionButtonBlock() {
				const self_ = this;
				const actionButton_ = self_.$_inpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.block)
			},
			$_inpLyt_styleQuestionActionButtonColor() {
				const self_ = this;
				const actionButton_ =self_.$_inpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.color)
			},
			$_inpLyt_styleQuestionActionButtonDark() {
				const self_ = this;
				const actionButton_ = self_.$_inpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.dark)
			},
			$_inpLyt_styleQuestionActionButtonDepressed() {
				const self_ = this;
				const actionButton_ = self_.$_inpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.depressed)
			},
			$_inpLyt_styleQuestionActionButtonElevation() {
				const self_ = this;
				const actionButton_ = self_.$_inpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.elevation)
			},
			$_inpLyt_styleQuestionActionButtonFlat() {
				const self_ = this;
				const actionButton_ = self_.$_inpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.flat)
			},
			$_inpLyt_styleQuestionActionButtonLarge() {
				const self_ = this;
				const actionButton_ = self_.$_inpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.large)
			},
			$_inpLyt_styleQuestionActionButtonLight() {
				const self_ = this;
				const actionButton_ = self_.$_inpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.light)
			},
			$_inpLyt_styleQuestionActionButtonOutlined() {
				const self_ = this;
				const actionButton_ = self_.$_inpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.outlined)
			},
			$_inpLyt_styleQuestionActionButtonRounded() {
				const self_ = this;
				const actionButton_ = self_.$_inpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.rounded)
			},
			$_inpLyt_styleQuestionActionButtonSmall() {
				const self_ = this;
				const actionButton_ = self_.$_inpLyt_styleQuestionActionButton;
				if(self_.isFalse(actionButton_)) { return null }
				return self_.getStylesVal(actionButton_.small)
			},
			// (content)
			$_inpLyt_styleContentImage() {
				return contentVals => {
					return contentVals.image
				}
			},
			$_inpLyt_styleContentImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_inpLyt_styleContentImage(contentVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			}
		},
		watch: {
			currentTime_: '$_inpLyt_checkTime'
		},
		created() {
			const self_ = this;
			// set initial input status
			self_.$_inpLyt_setInputState()
		},
		methods: {
			$_inpLyt_setInputState() {
				const self_ = this;

				self_.setInputState('pageName', self_.$_inpLyt_statePageName)
				self_.setInputState('pageType', self_.$_inpLyt_statePageType)

				let data_ = {}

				Object.keys(self_.contents).forEach(contentKey => {
					data_[contentKey] = {}

					// order
					data_[contentKey].order = self_.contents[contentKey].order;

					// question title & text
					data_[contentKey].question = {}
					data_[contentKey].question.title = self_.$_inpLyt_langContentTitle(self_.contents[contentKey])
					data_[contentKey].question.text = self_.$_inpLyt_langContentText(self_.contents[contentKey])

					// type
					Object.keys(self_.contents[contentKey].type).forEach(typeKey => {
						if(self_.contents[contentKey].type[typeKey]) { data_[contentKey].type = typeKey }
					})

					// default answer (empty or zero)
					if(		self_.contents[contentKey].type.combobox || // (free text)
							self_.contents[contentKey].type.textarea || 
							self_.contents[contentKey].type.textField ) { 
						data_[contentKey].answer = '';
					} else if(	self_.contents[contentKey].type.slider ) { 
						data_[contentKey].answer = 0
					} else if(	self_.contents[contentKey].type.comboboxMultiple || 
								self_.contents[contentKey].type.selectMultiple ) { 
						data_[contentKey].answer = [] 
					} else if(	self_.contents[contentKey].type.checkbox || 
								self_.contents[contentKey].type.switch ) { 
						data_[contentKey].answer = {}

						const options_ = self_.contents[contentKey].options

						Object.keys(options_).forEach(optionKey => {
							data_[contentKey].answer[optionKey] = {
								value: false,
								order: options_[optionKey].order,
								text: options_[optionKey].text,
								isCorrectAnswer: options_[optionKey].isCorrectAnswer
							}
						})
					} else { // radio, combobox (select option), select
						data_[contentKey].answer = {}
					}	

					// score
					data_[contentKey].score = self_.contents[contentKey].score;
				})

				self_.setInputState('data', data_)

				return
			},
			$_inpLyt_submit() {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				self_.mode_ = { 
					input: false,
					submit: true,
					finish: false
				}

				self_.stepNumber_++;

				self_.completed_ = { 
					input: true,
					submit: false,
					finish: false
				}

				vuetify_.goTo('#_inpLyt_top')
			},
			$_inpLyt_back() {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				self_.mode_ = { 
					input: true
				}

				self_.stepNumber_--;
				
				self_.completed_ = { 
					input: false,
					submit: false,
					finish: false
				}

				vuetify_.goTo('#_inpLyt_top')
			},
			$_inpLyt_confirm() {
				const self_ = this;
				const vuetify_ = self_.$vuetify;

				if(self_.onProgress_) { return }

				self_.onProgress_ = true;

				Promise.resolve().then(() => {
					return self_.storeInput()
				}).then(() => {
					self_.mode_ = { 
						input: false,
						submit: false,
						finish: true
					}

					self_.stepNumber_++;

					self_.completed_ = { 
						input: true,
						submit: true,
						finish: false
					}

					self_.onProgress_ = false;

					vuetify_.goTo('#_inpLyt_top')
				}).catch(error => {
					self_.errorMessage_ = error;

					vuetify_.goTo('#_inpLyt_top')

/* error */			self_.logError('Error', '$_inpLyt_confirm()', error)
				})
			}
		}
	}
</script>

<style scoped>
	.stepper_ {
		box-shadow: none !important;
		background-color: transparent !important;
	}
	.stepperHeader_ {
		background-color: transparent !important;
		box-shadow: none !important;
		height: 80px !important;
	}
	.stepperItem_ {
		background-color: transparent !important;
		box-shadow: none !important;
	}
	.stepperStep_ {
		padding: 16px !important;
	}
	.stepperContent_ {
		margin: 0 !important; 
		padding: 0 !important;
	}
</style>
